<template>
  <timeline-item
    :type="type"
    :date="date"
    :by-name="byName"
    icon="appointment"
    color="is-activities"
  >
<!--    <p>{{ appointmentInfo }}</p>-->
  </timeline-item>
</template>

<script>
import TimelineItem from "./TimelineItem";
import {ENUMS} from "../../services/enums";
import dates from "../../services/dates";

export default {
  name: "TimelineAppointment",
  components: {TimelineItem},
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  computed: {
    type() {
      let action = '';

      switch (this.appointment.action) {
        case ENUMS.ActivityActionEnum.Initial.value:
          action = 'Set';
          break;
        case ENUMS.ActivityActionEnum.Changed.value:
          action = 'Changed'
          break;
        case ENUMS.ActivityActionEnum.Canceled.value:
          action = 'Cancelled';
          break;
        default:
          action = '';
      }

      return 'Appointment ' + action;
    },
    title() {
      // TODO pipeline-overhaul Need to send appointment title in the activity payload and show it here
      // TODO pipeline-overhaul Afterward add the title attribute back to timeline-item
    },
    date() {
      return dates.formatAsDateTime(this.appointment.created_at);
    },
    byName() {
      return this.appointment.createdBy.display_name;
    },
    appointmentInfo() {
      // TODO pipeline-overhaul Need to get appointment info in the activity payload and show it here
      // TODO pipeline-overhaul Afterward uncomment out the line in template

      // Need to make this dynamic with appointment info
      return '2pm - 3:30pm Thur, Feb 11th with Danny Johnson, Shawn Pivonka'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

</style>
